import { match } from "ts-pattern";

import { CertificationKind } from "@/routes/_staff/certification/-constants";

const PathMap = {
  [CertificationKind.BASE]:
    "/person/$id/certifications/base-certifications/$personCertificationInformationId",
  [CertificationKind.SPECIALTY]:
    "/person/$id/certifications/specialty-certifications/$personCertificationInformationId",
  [CertificationKind.HANDLING]:
    "/person/$id/certifications/handling-certifications/$personCertificationInformationId",
} as const;

export const getCertificationKindToPath = (
  certificationKind: CertificationKind,
) => {
  return match(certificationKind)
    .with(CertificationKind.BASE, () => PathMap[CertificationKind.BASE])
    .with(
      CertificationKind.SPECIALTY,
      () => PathMap[CertificationKind.SPECIALTY],
    )
    .with(CertificationKind.HANDLING, () => PathMap[CertificationKind.HANDLING])
    .exhaustive();
};
